'use client'
import NextImage from 'next/image'
import { GalleryData } from '@/models/gallery'
import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectFade, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/navigation'

interface GalleryProps {
  className?: string
  data: GalleryData[]
}

const Gallery = ({ className = '', data = [] }: GalleryProps) => {
  return (
    <Swiper
      className={`gallery ${className}`}
      navigation={true}
      slidesPerView={1}
      modules={[EffectFade, Navigation]}
      effect="fade"
    >
      {data.map(({ id, name, photo }) => (
        <SwiperSlide key={id}>
          <div className="aspect-h-10 aspect-w-16">
            <NextImage
              alt={name}
              src={photo}
              fill
              sizes="100vw"
              className="rounded-lg object-cover object-center"
            />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  )
}

export default Gallery
